@use '@/styles/tokens' as *;

.stars {
  display: inline-flex;
  gap: var(--space-4);
}
.on {
  color: $color-warning-700; // was $color-warning-500 — didn't match this Figma frame
}
.off {
  color: $color-neutral-300;
}
